import { render } from "./HeroiconsOutlineScale.vue?vue&type=template&id=3222aa72"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineScale.vue"]])

export default __exports__